import React from 'react';
import { Button } from '@material-ui/core';
import { Control, UseFormSetValue, useFieldArray } from 'react-hook-form';
import { EditableQuestion } from '../../../../../types';
import FieldRow from './FieldRow';
import { StyledEmptyCell, StyledFieldGrid, StyledFieldHeading } from './styles';
import { createEmptyField } from './utils';

interface Props {
  control: Control<EditableQuestion>;
  setValue: UseFormSetValue<EditableQuestion>;
  toggleIndex: number;
}

const HEADINGS = ['Field id', 'Keyboard', 'Suffix', 'Decimals', 'Min', 'Max'];

// Placeholders disappear once a field has a value, so populated rows need standing
// headings to say which of the three numbers is which.
const FieldHeadings = () => (
  <StyledFieldGrid>
    {HEADINGS.map(heading => (
      <StyledFieldHeading key={heading}>{heading}</StyledFieldHeading>
    ))}
    <StyledEmptyCell aria-hidden />
  </StyledFieldGrid>
);

const FieldsEditor = ({ control, setValue, toggleIndex }: Props) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: `input.toggles.${toggleIndex}.fields` as 'input.toggles.0.fields',
    keyName: 'rhfKey' as 'id',
  });

  return (
    <>
      {Boolean(fields.length) && <FieldHeadings />}
      {fields.map((field, index) => (
        <FieldRow
          key={field.id}
          control={control}
          setValue={setValue}
          toggleIndex={toggleIndex}
          index={index}
          fieldId={field.id}
          onRemove={() => remove(index)}
        />
      ))}
      <Button variant="outlined" color="secondary" onClick={() => append(createEmptyField())}>
        Add field
      </Button>
    </>
  );
}

export default FieldsEditor;
